import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import Select from "react-select"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { getAllStatus } from "services/orders/calls"
import { getAllShippingCompanies } from "services/shipping-companies/calls"
import {
  addSupportRequestType,
  addSupportRequestTypeAuto,
  deleteSupportRequestType,
  getAllSupportRequestType,
  getQueues,
  patchSupportRequestType,
  patchSupportRequestTypeAuto,
  restoreSupportRequestType,
} from "services/support/calls"
import { getWorkflowTypes } from "services/workflows/calls"

const limit = 20

const initPageOptions = {
  sizePerPage: limit,
  totalSize: 0,
  custom: true,
  showTotal: true,
  hideSizePerPage: true,
  hidePageListOnlyOnePage: true,
  prePageText: "Anterior",
  nextPageText: "Próximo",
  paginationTotalRenderer: () => {
    return (
      <div className="d-inline">
        <span className="react-bootstrap-table-pagination-total">
          Registros Retornados: {total}
        </span>
      </div>
    )
  },
}

const TipoChamado = props => {
  document.title = "Cadastro de Tipos de Chamado | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  const nameRef = useRef()
  const slaRef = useRef()
  const descRef = useRef()
  const isAutoRef = useRef()

  const [isAutoNew, setIsAutoNew] = useState(false)

  const novoNameRef = useRef()
  const novoSlaRef = useRef()
  const novoDescRef = useRef()
  const [isLoading, setIsLoading] = useState(true)

  const [newIsCourrier, setNewIsCourrier] = useState(false)
  const [newTransportadora, setNewTransportadora] = useState([])
  const [newWorkflowType, setNewWorkflowType] = useState([])

  const [alterIsCourrier, setAlterIsCourrier] = useState(false)
  const [alterTransportadora, setAlterTransportadora] = useState({})

  const [chamado, setChamado] = useState({})
  const [chamadoModal, setChamadoModal] = useState(false)
  const [queues, setQueues] = useState([])
  const [novasFilas, setNovasFilas] = useState([])
  const [novaFailedQueue, setNovaFailedQueue] = useState([])
  const [statusFila, setStatusFila] = useState([])
  const [statusFinalizador, setStatusFinalizador] = useState([])
  const [supportRequestTypes, setSupportRequestTypes] = useState([])

  const [patchFilas, setPatchFilas] = useState([])
  const [patchFailQueue, setPatchFailQueue] = useState([])
  const [patchFinisherCode, setPatchFinisherCode] = useState([])
  const [patchStatusFila, setPatchStatusFila] = useState([])
  const [patchWorkflowType, setPatchWorkflowType] = useState([])

  const [modalNovoTipo, setModalNovoTipo] = useState(false)
  const [modalPatchTipo, setModalPatchTipo] = useState(false)

  const [status, setStatus] = useState([])
  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [transportadoras, setTransportadoras] = useState([])
  const [workflowTypes, setWorkflowTypes] = useState([])

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const fetchSupportRequestTypes = async () => {
    try {
      const supportRequestTypes = await getAllSupportRequestType()
      setSupportRequestTypes(supportRequestTypes)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchQueues = async () => {
    const queues = await getQueues()
    setQueues(queues)
  }

  const fetchStatus = async () => {
    const status = await getAllStatus()
    setStatus(status)
  }

  useEffect(() => {
    const fecthCourriers = async () => {
      try {
        const { payload } = await getAllShippingCompanies()
        const { companies } = payload
        setTransportadoras(companies)
      } catch (error) {
        console.error(error)
      }
    }
    const fecthWorkflowTypes = async () => {
      try {
        const { payload } = await getWorkflowTypes()
        const { workflowTypes } = payload
        setWorkflowTypes(workflowTypes)
      } catch (error) {
        console.error(error)
      }
    }
    try {
      setIsLoading(true)
      fecthWorkflowTypes()
      fecthCourriers()
      fetchQueues()
      fetchStatus()
      fetchSupportRequestTypes()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const queuesOptions = queues.map(q => ({ value: q.id, label: q.name }))
  const workflowTypesOptions = workflowTypes.map(w => ({
    value: w.id,
    label: w.name,
  }))

  const failQueueOptions = queues
    .filter(qf => {
      if (newIsCourrier || alterIsCourrier) {
        if (
          qf?.shippingCompanyId === newTransportadora.value ||
          qf?.shippingCompanyId === alterTransportadora.value ||
          qf?.shippingCompanyId == null
        ) {
          return true
        } else {
          return false
        }
      } else {
        return qf?.shippingCompanyId === null
      }
    })
    .map(q => ({ value: q.id, label: q.name }))

  // const failQueueOptions = queues
  //   .filter(qf =>
  //     newIsCourrier || alterIsCourrier
  //       ? qf?.shippingCompanyId ==
  //           (newTransportadora.value || alterTransportadora.value) ||
  //         qf?.shippingCompanyId == null
  //       : qf?.shippingCompanyId === null
  //   )
  //   .map(q => ({ value: q.id, label: q.name }))

  const statusOptions = status.map(s => ({ value: s.id, label: s.name }))

  const courierOptions = transportadoras.map(t => ({
    value: t.id,
    label: t.name,
  }))

  const queueHandleChange = options => {
    setNovasFilas(options)
  }

  const failedQueueHandleChange = options => {
    setNovaFailedQueue(options)
  }

  const statusHandleChange = options => {
    setStatusFila(options)
  }

  const statusFinalizadorHandleChange = options => {
    setStatusFinalizador(options)
  }

  const newWorkflowTypeHandleChange = options => {
    setNewWorkflowType(options)
  }

  const queuePatchHandleChange = options => {
    setPatchFilas(options)
  }

  const failedQueuePatchHandleChange = options => {
    setPatchFailQueue(options)
  }

  const statusPatchHandleChange = options => {
    setPatchStatusFila(options)
  }

  const statusFinalizadorPatchHandleChange = options => {
    setPatchFinisherCode(options)
  }

  const patchWorkflowTypeHandleChange = options => {
    setPatchWorkflowType(options)
  }

  const fetchValuesForSelect = config => {
    const queuesPatch = JSON.parse(config)?.queues
    const statusPatch = JSON.parse(config)?.orderStatus
    const failQueue = JSON.parse(config)?.failQueue
    const finisherCode = JSON.parse(config)?.finisherCode
    setPatchFilas(
      Array.isArray(queuesPatch)
        ? queuesPatch.map(q => {
            // TODO: ver com o tonho sobre fila que não tem mais mapeada
            if (q && queues.find(e => e.id === q)) {
              return {
                value: q,
                label: queues.find(e => e.id === q)?.name,
              }
            }
          })
        : []
    )
    setPatchStatusFila(
      Array.isArray(statusPatch)
        ? statusPatch.map(s => {
            return {
              value: s,
              label: status.find(e => e.id === s)?.name,
            }
          })
        : []
    )
    setPatchFailQueue(
      failQueue
        ? { value: failQueue, label: queues.find(e => e.id === failQueue).name }
        : {}
    )
    setPatchFinisherCode(
      Array.isArray(finisherCode)
        ? finisherCode.map(s => {
            return {
              value: s,
              label: status.find(e => e.id === s)?.name,
            }
          })
        : []
    )
  }

  const handlePatchSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const novoNome = novoNameRef.current.value || chamado.name
      const novoSla =
        novoSlaRef.current.value || JSON.parse(chamado.config)?.sla
      const novoDesc =
        novoDescRef.current.value || JSON.parse(chamado.config)?.details
      let newQueues
      if (Array.isArray(patchFilas)) {
        newQueues = [
          ...patchFilas.map(nf => {
            if (nf) {
              return nf.value
            }
          }),
        ]
      }
      if (chamado?.isAuto) {
        if (alterIsCourrier) {
          await patchSupportRequestTypeAuto(chamado.id, {
            name: novoNome,
            details: novoDesc,
            sla: novoSla,
            isAuto: true,
            queues: newQueues,
            failQueue: patchFailQueue.value,
            finisherCode: patchFinisherCode.map(fc => fc.value),
            orderStatus: patchStatusFila.map(sf => sf.value),
            shippingCompanyId: alterTransportadora.value,
            workflowTypeId: patchWorkflowType.value,
          })
        } else {
          await patchSupportRequestTypeAuto(chamado.id, {
            name: novoNome,
            details: novoDesc,
            sla: novoSla,
            isAuto: true,
            queues: newQueues,
            failQueue: patchFailQueue.value,
            finisherCode: patchFinisherCode.map(fc => fc.value),
            orderStatus: patchStatusFila.map(sf => sf.value),
            shippingCompanyId: null,
            workflowTypeId: patchWorkflowType.value,
          })
        }
      } else {
        if (alterIsCourrier) {
          await patchSupportRequestType(chamado.id, {
            name: novoNome,
            details: novoDesc,
            sla: novoSla,
            queues: newQueues,
            isAuto: false,
            orderStatus: patchStatusFila.map(sf => sf.value),
            shippingCompanyId: alterTransportadora.value,
          })
        } else {
          await patchSupportRequestType(chamado.id, {
            name: novoNome,
            details: novoDesc,
            sla: novoSla,
            queues: newQueues,
            isAuto: false,
            orderStatus: patchStatusFila.map(sf => sf.value),
            shippingCompanyId: null,
          })
        }
      }

      fetchSupportRequestTypes()
      toast("success", "Tipo de Chamado atualizado com sucesso!")
    } catch (error) {
      toast("warning", "Falha ao atualizar tipo de chamado.")
      console.log(error)
    } finally {
      setModalPatchTipo(false)
      setIsLoading(false)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      if (nameRef.current.value) {
        const newQueues = [...novasFilas.map(nf => nf.value)]
        if (isAutoNew) {
          if (newIsCourrier) {
            await addSupportRequestTypeAuto({
              name: nameRef.current.value,
              details: descRef.current.value,
              sla: slaRef.current.value,
              isAuto: true,
              queues: newQueues,
              failQueue: novaFailedQueue.value,
              finisherCode: statusFinalizador.map(fc => fc.value),
              orderStatus: statusFila.map(sf => sf.value),
              shippingCompanyId: newTransportadora.value,
              workflowTypeId: newWorkflowType.value,
            })
          } else {
            await addSupportRequestTypeAuto({
              name: nameRef.current.value,
              details: descRef.current.value,
              sla: slaRef.current.value,
              isAuto: true,
              queues: newQueues,
              failQueue: novaFailedQueue.value,
              finisherCode: statusFinalizador.map(fc => fc.value),
              orderStatus: statusFila.map(sf => sf.value),
              shippingCompanyId: null,
              workflowTypeId: newWorkflowType.value,
            })
          }
        } else {
          if (newIsCourrier) {
            await addSupportRequestType({
              name: nameRef.current.value,
              details: descRef.current.value,
              sla: slaRef.current.value,
              queues: newQueues,
              isAuto: false,
              orderStatus: statusFila.map(sf => sf.value),
              shippingCompanyId: newTransportadora.value,
            })
          } else {
            await addSupportRequestType({
              name: nameRef.current.value,
              details: descRef.current.value,
              sla: slaRef.current.value,
              queues: newQueues,
              isAuto: false,
              orderStatus: statusFila.map(sf => sf.value),
              shippingCompanyId: null,
            })
          }
        }
        fetchSupportRequestTypes()
        toast("success", "Tipo de Chamado adicionado com sucesso!")
      } else {
        toast(
          "warning",
          "Não é possível adicionar tipo de chamado com nome vazio."
        )
      }
    } catch (error) {
      toast("warning", "Falha ao criar tipo de chamado.")
      console.log(error)
    } finally {
      setModalNovoTipo(false)
      setIsLoading(false)
    }
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
    },
    {
      dataField: "status",
      isDummyField: true,
      text: "Situação",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) =>
        row.deletedAt ? (
          <Badge color="warning" className="me-1">
            <b>Inativo</b>
          </Badge>
        ) : (
          <Badge color="primary" className="me-1">
            <b>Ativo</b>
          </Badge>
        ),
    },
    {
      dataField: "isAuto",
      isDummyField: true,
      text: "Tipo de Fluxo",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) =>
        row.isAuto == 1 ? (
          <Badge color="success" className="me-1">
            <b>Automático</b>
          </Badge>
        ) : (
          <Badge color="warning" className="me-1">
            <b>Manual</b>
          </Badge>
        ),
    },
    {
      dataField: "createdAt",
      text: "Criação",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => (
        <b>{moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")}</b>
      ),
    },
    {
      dataField: "updatedAt",
      text: "Atualização",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => (
        <b>
          {row.updatedAt
            ? moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")
            : "-"}
        </b>
      ),
    },
    {
      dataField: "description",
      isDummyField: true,
      text: "Descrição",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "5%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-secondary`}
              onClick={() => {
                setChamado(row)
                setChamadoModal(true)
              }}
            >
              <i
                className="mdi mdi-format-list-bulleted"
                id={`detailToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip
              placement="top"
              target={`detailToolTip${row.id}`}
            >
              Descrição
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "7%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              disabled={isLoading}
              onClick={() => {
                setChamado(row)
                // console.log(row)
                // console.log(workflowTypes)
                setPatchWorkflowType(
                  row?.workflowTypeId
                    ? {
                        value: row?.workflowTypeId,
                        label: workflowTypes.find(
                          wf => wf.id === row?.workflowTypeId
                        ).name,
                      }
                    : []
                )
                setAlterIsCourrier(row?.shippingCompanyId ? true : false)
                setAlterTransportadora(
                  row?.shippingCompanyId
                    ? {
                        value: row?.shippingCompanyId,
                        label: transportadoras.find(
                          t => t.id === row?.shippingCompanyId
                        ).name,
                      }
                    : []
                )
                setModalPatchTipo(true)
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              disabled={row?.isAuto}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setIsLoading(true)
                    await restoreSupportRequestType(row.id)
                    fetchSupportRequestTypes()
                    toast("success", "Step ativado com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar step.")
                    console.log(error)
                  } finally {
                    setIsLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>
                          Esta ação ira desabilitar esta opção de tipo de
                          chamado.
                        </p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este tipo de chamado de atendimento?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setIsLoading(true)
                      try {
                        await deleteSupportRequestType(row.id)
                        fetchSupportRequestTypes()
                        toast("success", "Tipo de chamado apagado com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao apagar tipo de chamado.")
                        console.log(error)
                      } finally {
                        setIsLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className="mdi mdi-delete-forever"
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[
              { title: props.t("Tipos de Chamados"), path: "#" },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  Lista de Tipos
                  <Button
                    className="float-end btn-sm"
                    onClick={() => {
                      setIsAutoNew(false)
                      setNewIsCourrier(false)
                      setAlterIsCourrier(false)
                      setModalNovoTipo(true)
                    }}
                  >
                    Adicionar
                  </Button>
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (supportRequestTypes.length > 0 ? (
                      <PaginationProvider
                        pagination={paginationFactory(initPageOptions)}
                        keyField="id"
                        columns={columns}
                        data={supportRequestTypes}
                      >
                        {({ paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            columnToggle
                            data={supportRequestTypes}
                            search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <BootstrapTable
                                      keyField={"id"}
                                      bordered={true}
                                      striped={true}
                                      condensed
                                      defaultSorted={defaultSorted}
                                      selectRow={selectRow}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={chamadoModal}
        toggle={() => {
          setChamadoModal(!chamadoModal)
        }}
        centered
      >
        <ModalHeader>
          Descrição
          <button
            type="button"
            onClick={() => {
              setChamadoModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <pre>{chamado?.name}</pre>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <pre>
                  {JSON.stringify(JSON.parse(chamado?.config || "{}"), null, 2)}
                </pre>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalNovoTipo}
        size="lg"
        toggle={() => {
          setModalNovoTipo(!modalNovoTipo)
        }}
        centered
      >
        <ModalHeader>
          Adicionar novo Tipo de Chamado
          <button
            type="button"
            onClick={() => {
              setModalNovoTipo(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("Nome do Tipo de Chamado")}</Label>
                  <Input
                    required
                    type="text"
                    className="form-control"
                    placeholder="Tipo de Chamado"
                    ref={nameRef}
                    disabled={isLoading}
                    onChange={e => {
                      nameRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>{t("SLA")}</Label>
                  <Input
                    required
                    type="number"
                    className="form-control"
                    placeholder="SLA"
                    ref={slaRef}
                    disabled={isLoading}
                    onChange={e => {
                      slaRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    ref={isAutoRef}
                    disabled={isLoading}
                    onChange={e => {
                      isAutoRef.current.checked = e.target.checked
                      setIsAutoNew(e.target.checked)
                    }}
                  />{" "}
                  <Label check>Automático?</Label>
                </FormGroup>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("Descrição do Tipo de Chamado")}</Label>
                  <Input
                    type="textarea"
                    maxLength="1500"
                    rows="6"
                    className="form-control"
                    placeholder="Descrição"
                    ref={descRef}
                    disabled={isLoading}
                    onChange={e => {
                      descRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    checked={newIsCourrier}
                    onChange={e => {
                      setNewIsCourrier(e.target.checked)
                      if (!e.target.checked) {
                        setNovaFailedQueue([])
                      }
                    }}
                  />{" "}
                  <Label check>Transportadora?</Label>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>{t("Transportadora")}</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    isDisabled={!newIsCourrier}
                    options={courierOptions}
                    placeholder="Transportadora"
                    value={newTransportadora}
                    onChange={e => {
                      setNewTransportadora(e)
                      setNovaFailedQueue([])
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Filas</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    name="newQueues"
                    required
                    isMulti
                    disabled={isLoading}
                    options={queuesOptions}
                    placeholder="Filas Disponíveis"
                    onChange={queueHandleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            {isAutoNew && (
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Fila de Erro</Label>
                    <Select
                      classNamePrefix="reactSelect"
                      name="newFailQueue"
                      required
                      isMulti={!isAutoNew}
                      disabled={isLoading}
                      options={failQueueOptions}
                      value={novaFailedQueue}
                      placeholder="Filas Disponíveis"
                      onChange={failedQueueHandleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <FormGroup>
                  <Label>Status</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    name="newStatus"
                    required
                    isMulti
                    disabled={isLoading}
                    options={statusOptions}
                    placeholder="Status que este tipo poderá ser usado"
                    onChange={statusHandleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            {isAutoNew && (
              <>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Status Finalizador</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        name="newFinisherCode"
                        required
                        isMulti
                        disabled={isLoading}
                        options={statusOptions}
                        placeholder="Status Finalizador"
                        onChange={statusFinalizadorHandleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Tipo de Fluxo</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        name="newWorkflowType"
                        required
                        disabled={isLoading}
                        options={workflowTypesOptions}
                        placeholder="Tipo de Fluxos"
                        onChange={newWorkflowTypeHandleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                setModalNovoTipo(false)
              }}
              disabled={isLoading}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {t("Cancelar")}
            </Button>
            <Button
              className="btn btn-primary"
              data-dismiss="modal"
              disabled={isLoading}
              type="submit"
            >
              {t("Adicionar")}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal
        isOpen={modalPatchTipo}
        size="lg"
        toggle={() => {
          setModalPatchTipo(!modalPatchTipo)
        }}
        centered
        onOpened={() => {
          fetchValuesForSelect(chamado?.config)
        }}
      >
        <ModalHeader>
          Alterar Tipo de Chamado
          <button
            type="button"
            onClick={() => {
              setModalPatchTipo(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <Form onSubmit={handlePatchSubmit}>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("Nome do Tipo de Chamado")}</Label>
                  <Input
                    type="text"
                    className="form-control"
                    readOnly={chamado?.isAuto}
                    defaultValue={chamado?.name}
                    ref={novoNameRef}
                    disabled={isLoading}
                    onChange={e => {
                      novoNameRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>{t("SLA")}</Label>
                  <Input
                    type="number"
                    className="form-control"
                    ref={novoSlaRef}
                    defaultValue={JSON.parse(chamado?.config || "{}")?.sla}
                    disabled={isLoading}
                    onChange={e => {
                      novoSlaRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    disabled={true}
                    checked={chamado?.isAuto}
                  />{" "}
                  <Label check>Automático?</Label>
                </FormGroup>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("Descrição do Tipo de Chamado")}</Label>
                  <Input
                    type="textarea"
                    maxLength="1500"
                    rows="6"
                    className="form-control"
                    ref={novoDescRef}
                    defaultValue={JSON.parse(chamado?.config || "{}")?.details}
                    disabled={isLoading}
                    onChange={e => {
                      novoDescRef.current.value = e.target.value
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    checked={alterIsCourrier}
                    onChange={e => {
                      setAlterIsCourrier(e.target.checked)
                      if (!e.target.checked) {
                        setPatchFailQueue([])
                      }
                    }}
                  />{" "}
                  <Label check>Transportadora?</Label>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>{t("Transportadora")}</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    isDisabled={!alterIsCourrier}
                    options={courierOptions}
                    placeholder="Transportadora"
                    value={alterTransportadora}
                    onChange={e => {
                      setAlterTransportadora(e)
                      setPatchFailQueue([])
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Filas</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    name="patchQueues"
                    required
                    isMulti
                    options={queuesOptions}
                    disabled={isLoading}
                    value={patchFilas}
                    placeholder="Filas Disponíveis"
                    onChange={queuePatchHandleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            {chamado?.isAuto && (
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Fila de Erro</Label>
                    <Select
                      classNamePrefix="reactSelect"
                      name="patchFailQueue"
                      required
                      isMulti={!chamado?.isAuto}
                      options={failQueueOptions}
                      disabled={isLoading}
                      value={patchFailQueue}
                      placeholder="Filas Disponíveis"
                      onChange={failedQueuePatchHandleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <FormGroup>
                  <Label>Status</Label>
                  <Select
                    classNamePrefix="reactSelect"
                    name="patchStatus"
                    required
                    isMulti
                    options={statusOptions}
                    disabled={isLoading}
                    value={patchStatusFila}
                    placeholder="Status que este tipo poderá ser usado"
                    onChange={statusPatchHandleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            {chamado?.isAuto && (
              <>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Status Finalizador</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        name="patchFinisherCode"
                        required
                        isMulti
                        options={statusOptions}
                        disabled={isLoading || chamado?.isAuto}
                        value={patchFinisherCode}
                        placeholder="Status Finalizador"
                        onChange={statusFinalizadorPatchHandleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Tipo de Fluxo</Label>
                      <Select
                        classNamePrefix="reactSelect"
                        name="patchWorkflowType"
                        required
                        disabled={isLoading}
                        options={workflowTypesOptions}
                        value={patchWorkflowType}
                        placeholder="Tipo de Fluxos"
                        onChange={patchWorkflowTypeHandleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                setModalPatchTipo(false)
              }}
              disabled={isLoading}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {t("Cancelar")}
            </Button>
            <Button
              className="btn btn-primary"
              data-dismiss="modal"
              disabled={isLoading}
              type="submit"
            >
              {t("Alterar")}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  )
}

export default withTranslation()(TipoChamado)
